import { useEffect, useState } from "react";

function TimelineItem({
    visible,
    position,
    image,
    company,
    duration,
    role,
    description,
}) {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState("");
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick(role);
            // tick(position);
        }, delta);

        return () => {
            clearInterval(ticker);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    const tick = (txt) => {
        let updatedText = isDeleting
            ? txt.substring(0, text.length - 1)
            : txt.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta((prevDelta) => prevDelta / 2);
        }

        if (!isDeleting && updatedText === txt) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText === "") {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    };


    return (
        <div className=" grid grid-cols-1 md:grid-cols-[2fr_auto_2fr] md:gap-6 text-[#93a2b8]">
            <div className={position !== "even" ? 'space-y-1 md:text-right order-2 md:order-1' : 'order-2 md:order-3 md:text-left space-y-1'}>
                <h3 className=" text-lg md:text-sm font-bold md:font-semibold">
                    {company}
                </h3>
                <p className="text-xs">
                    {duration}
                </p>
            </div>

            <div className="relative hidden md:flex flex-col md:items-center order-1 md:order-2">
                <div className={visible && "absolute top-0 h-full w-px bg-gray-300"}></div>
                <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-white border border-gray-300">
                    <img
                        src={image}
                        alt={company}
                        className="h-10 w-10 rounded-full object-cover"
                    />
                </div>
            </div>
            <div className={position !== "even" ? 'space-y-2 mt-3 order-3' : 'space-y-2 mt-3 order-3 md:order-1'}>
                <h4 className="text-sm font-semibold">
                    {text}
                </h4>
                <p className="text-sm leading-relaxed md:pb-2 pb-6">
                    {description}
                </p>
            </div>
        </div>
    );
};

export default TimelineItem;